import { _ as __assign } from '../../chunks/bundle-Ca6003_X.js';
import React__default from 'react';
import { R as RemoveMessageModalView } from '../../chunks/bundle-aoJ63sHH.js';
import { u as useGroupChannel } from '../../chunks/bundle-CGu41Cov.js';
import '../../chunks/bundle-CCo7ZdMR.js';
import 'react-dom';
import '../../chunks/bundle-91Yg-xh6.js';
import '../../chunks/bundle-s19NuPaM.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../chunks/bundle-DGylLBIn.js';
import '../../chunks/bundle-CPSJLEbT.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-C6Xiexo0.js';
import '../../chunks/bundle-ByN2OJfK.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-CK16SjUd.js';
import '../../chunks/bundle-BVK-TCRK.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DDAJSpJT.js';
import '../../chunks/bundle-DrrIZ2Uk.js';
import '../../chunks/bundle-DUh4gAyx.js';
import '@sendbird/chat/message';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-C6mXReBM.js';
import '../../chunks/bundle-Dwuqku8L.js';
import '../../chunks/bundle-DxuHs_7y.js';
import '../../chunks/bundle-DgPFpYZt.js';
import '../../chunks/bundle-CyNQH9Yl.js';
import '../../chunks/bundle-B2eoNpzc.js';
import '../../chunks/bundle-_G98ZxIs.js';
import '../../chunks/bundle-CiiVQ3uH.js';

var RemoveMessageModal = function (props) {
    var deleteMessage = useGroupChannel().actions.deleteMessage;
    return React__default.createElement(RemoveMessageModalView, __assign({}, props, { deleteMessage: deleteMessage }));
};

export { RemoveMessageModal, RemoveMessageModal as default };
//# sourceMappingURL=RemoveMessageModal.js.map
